import { render, staticRenderFns } from "./PermissionsSelect.vue?vue&type=template&id=32614037&"
import script from "./PermissionsSelect.vue?vue&type=script&lang=js&"
export * from "./PermissionsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports